<template>
  <div id="app">
    <global-header />
    <b-container class="main-container">
      <b-row class="text-center d-flex justify-content-center" cols="1">
        <b-col class="pdf-section">
          <div
            v-for="i in numPages"
            :key="i"
            class="pdf-page-wrapper"
          >
            <pdf
              :src="pdfSrc"
              :page="i"
            ></pdf>
          </div>

          <b-row class="justify-content-end">
                <b-link href="Jeffectリーフレット.pdf" download="Jeffectリーフレット.pdf"  class="pdf-download-button btn-sm">PDFダウンロード</b-link>
          </b-row>
        </b-col>
        <b-col><div class="section-separator"></div></b-col>
        <b-col class="mail-form-section" cols="12">
          <div class="iframe-wrapper">
            <iframe src="https://shuuji.co.jp/script/mailform/jeffect/" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" scrolling="auto"></iframe>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <global-footer />
  </div>
</template>

<script>
import GlobalFooter from "../../components/GlobalFooter.vue";
import GlobalHeader from "../../components/GlobalHeader.vue";
import pdf from "vue-pdf";

export default {
  name: "app",
  components: {
    GlobalHeader,
    GlobalFooter,
    pdf,
  },
  data() {
    return {
      pdfSrc: pdf.createLoadingTask(require('../../../public/Jeffectリーフレット.pdf')),
      numPages: 0,
    };
  },
  mounted() {
    this.pdfSrc.promise.then(pdf => {
      this.numPages = pdf.numPages;
    });
  },
}
</script>

<style scoped>
@media only screen and (max-width: 750px) {
  html {
    font-size: 62.5%;
  }
}

@media only screen and (min-width: 750px) {
  html {
    font-size: 75%;
  }
}

#app,
body {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-container {
  margin-top: 1rem;
  max-width: 900px;
}

/* PDFページ間の余白 */
.pdf-page-wrapper {
  margin-bottom: 1.0rem;
}

.pdf-page-wrapper:last-child {
  margin-bottom: 0;
}

.pdf-download-button {
  margin-top: 1rem;
  margin-right: 15px;
  display: inline-block;
  padding: 0.3em 1em;
  text-decoration: none;
  color:#6c757d;
  border: solid 2px #808080FF;
  border-radius: 3px;
  transition: .4s;
}

.pdf-download-button:hover {
  background: #6c757d;
  color: white;
}

.section-separator {
  height: 2.6rem;
}

@media only screen and (max-width: 732px) {
  .iframe-wrapper {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 100%;
  }

  .iframe-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

@media only screen and (min-width: 732px) {
  .iframe-wrapper {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 75%;
  }

  .iframe-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
